/* @flow */
import type { ReduxState, Action, Fetchable, Category } from '../../types';
// ===========================
//   STATE TYPE
// ===========================
export type CategoriesState = {
  categories: Fetchable<Category[]>,
};

// ===========================
//   INITIAL STATE
// ===========================
export const initialState: CategoriesState = {
  categories: { fetching: false },
};

// ===========================
//   REDUCER
// ===========================
const categoriesOrder = [7, 8, 9, 5, 3, 4, 2];
export default (state: CategoriesState = initialState, action: Action): CategoriesState => {
  switch (action.type) {
    case 'FETCH_CATEGORIES_REQUEST': {
      return {
        ...state,
        categories: { fetching: true },
      };
    }
    case 'FETCH_CATEGORIES_SUCCESS': {
      const missingOrder = action.payload.filter(
        category => !categoriesOrder.includes(category.id)
      );
      const data = categoriesOrder
        .map(categoryId => action.payload.find(category => categoryId === category.id))
        .filter(_ => _ !== null);
      return {
        ...state,
        categories: { data: [...data, ...missingOrder], fetching: false },
      };
    }
    case 'FETCH_CATEGORIES_FAILURE': {
      const error = action.payload;
      return {
        ...state,
        categories: { error, fetching: false },
      };
    }
    case 'LOGOUT_SUCCESS':
      return initialState;

    default: {
      return state;
    }
  }
};

// ===========================
//   SELECTORS
// ===========================

export const getCategories = (state: ReduxState): Fetchable<Category[]> => {
  return state.categories.categories;
};
